import http from './http'

// 获取列表
export function pageList (data) {
  return http.post('/client/market/comment/user/pagelist', data)
}

// 删除同步项
export function remove (key) {
  return http.post(`/client/market/comment/${key}`)
}
